import styled from 'styled-components';

export const EmailStepWrapper = styled('div')`
  ${({
    theme: {
      spacing, colors, breakpoint, rounded,
    },
  }) => `
    background: ${colors.white};
    box-shadow: ${spacing.none} ${spacing.px10} ${spacing.px30} ${colors.grey2};
    border-radius: ${rounded.px10};
    margin-top:20px;
    padding: 40px 68px 58px 68px;
    width: 500px;
    height:420px;
    max-width: ${spacing.full};
    box-sizing: border-box;
    @media screen and (max-width: ${breakpoint.sm}) {
      background:none;
      box-shadow:none;
      width:100%;
      padding: 0;
    }
  `}
`;

export const InputWrapper = styled('div')`
  ${({ theme: { breakpoint } }) => `
    width:400px;
    margin-top:80px;
    background:none;
    @media screen and (max-width: ${breakpoint.sm}) {
      width:100%;
    }
  `}
`;

export const EmailTitle = styled('div')`
 ${({ theme: { breakpoint } }) => `
    font-size: 24px;
    text-align: center;
    color: #0C2833;
    max-width:368px;
    margin-left:auto;
    margin-right:auto;
    @media screen and (max-width: ${breakpoint.sm}) {
      font-size: 20px;
      padding-left: 15px;
      padding-right: 15px;
    }
  `}
`;

export const InputEmail = styled.input`
  background-color: transparent;
  border: none;
  border-bottom: 1px #cecece solid;
  font-size: 20px;
  padding-bottom: 14px;
  color: #4c5564;
  width: 100%;
  &:focus {
      outline: none;
  }
`;

export const ButtonWrapper = styled('div')`
${({ theme }) => `
    align-self: flex-end;
    margin-top:105px;

    & > Button  {
        width:100%;
        height:56px;
        @media screen and (min-width: ${theme.breakpoint.sm}) {
            width: 130px;
            height:40px;
            float:right;
        }

    }
`}
`;
